import 'svelte/internal/disclose-version';
import * as $ from 'svelte/internal/client';
import Modal from '../shared/Modal.svelte';
import SegmentedControl from '../shared/SegmentedControl.svelte';
import Button from '../shared/Button.svelte';
import { createReminder, requestNotificationPermission } from '../../lib/services/reminders';
import { getActiveChild } from '../../lib/stores/children.svelte.ts';
import { showToast } from '../shared/Toast.svelte';

var root_1 = $.from_html(`<div class="reminder-form svelte-39yhbnnw1oe2y"><div class="field svelte-39yhbnnw1oe2y"><label class="svelte-39yhbnnw1oe2y">Type</label> <!></div> <div class="field svelte-39yhbnnw1oe2y"><label class="svelte-39yhbnnw1oe2y">Interval</label> <!></div> <div class="field svelte-39yhbnnw1oe2y"><label class="svelte-39yhbnnw1oe2y">Label (optional)</label> <input type="text" class="svelte-39yhbnnw1oe2y"/></div> <!></div>`);

function ReminderForm($$anchor, $$props) {
	$.push($$props, true);

	let type = $.state('pump');
	let intervalHours = $.state('3');
	let label = $.state('');

	const typeOptions = [
		{ value: 'pump', label: 'Pump' },
		{ value: 'feed', label: 'Feed' },
		{ value: 'hydration', label: 'Water' },
		{ value: 'meal', label: 'Meal' }
	];

	const intervalOptions = [
		{ value: '2', label: '2h' },
		{ value: '3', label: '3h' },
		{ value: '4', label: '4h' }
	];

	const defaultLabels = {
		pump: 'Time to pump',
		feed: 'Feeding reminder',
		hydration: 'Drink some water',
		meal: 'Time for a meal'
	};

	async function handleSave() {
		const activeChild = getActiveChild();

		if (!activeChild) {
			showToast('No active child selected.', 'error');

			return;
		}

		try {
			await requestNotificationPermission();

			const hrs = parseFloat($.get(intervalHours)) || 3;
			const ms = hrs * 60 * 60 * 1000;

			await createReminder(activeChild.id, $.get(type), ms, $.get(label) || defaultLabels[$.get(type)] || 'Reminder');
			$$props.onsaved();
			$$props.onclose();
			$.set(type, 'pump');
			$.set(intervalHours, '3');
			$.set(label, '');
		} catch(e) {
			showToast('Failed to create reminder. Please try again.', 'error');
		}
	}

	var fragment = $.comment();
	var node = $.first_child(fragment);

	Modal(node, {
		get open() {
			return $$props.open;
		},

		get onclose() {
			return $$props.onclose;
		},
		title: 'New Reminder',
		children: ($$anchor, $$slotProps) => {
			var div = root_1();
			var div_1 = $.child(div);
			var node_1 = $.sibling($.child(div_1), 2);

			SegmentedControl(node_1, {
				get options() {
					return typeOptions;
				},

				get selected() {
					return $.get(type);
				},
				onchange: (v) => $.set(type, v, true)
			});

			$.reset(div_1);

			var div_2 = $.sibling(div_1, 2);
			var node_2 = $.sibling($.child(div_2), 2);

			SegmentedControl(node_2, {
				get options() {
					return intervalOptions;
				},

				get selected() {
					return $.get(intervalHours);
				},
				onchange: (v) => $.set(intervalHours, v, true)
			});

			$.reset(div_2);

			var div_3 = $.sibling(div_2, 2);
			var input = $.sibling($.child(div_3), 2);

			$.remove_input_defaults(input);
			$.reset(div_3);

			var node_3 = $.sibling(div_3, 2);

			Button(node_3, {
				variant: 'primary',
				fullWidth: true,
				onclick: handleSave,
				children: ($$anchor, $$slotProps) => {
					$.next();

					var text = $.text('Create Reminder');

					$.append($$anchor, text);
				},
				$$slots: { default: true }
			});

			$.reset(div);
			$.template_effect(() => $.set_attribute(input, 'placeholder', defaultLabels[$.get(type)]));
			$.bind_value(input, () => $.get(label), ($$value) => $.set(label, $$value));
			$.append($$anchor, div);
		},
		$$slots: { default: true }
	});

	$.append($$anchor, fragment);
	$.pop();
}

if (import.meta.hot) {
	ReminderForm = $.hmr(ReminderForm);

	import.meta.hot.accept((module) => {
		$.cleanup_styles('svelte-39yhbnnw1oe2y');
		ReminderForm[$.HMR].update(module.default);
	});
}

export default ReminderForm;
import "bun-svelte:ReminderForm.svelte-2wz3jgycx425s-style.css";